export default "__VITE_PUBLIC_ASSET__e1bc858b__"